import { Pipe, PipeTransform } from "@angular/core";

import { FilterLeftPadd } from "./filter.left.padd";

@Pipe({
    name: "filterSecToTime"
    ,pure: false
})
export class FilterSecToTime implements PipeTransform {
    day:number = 0;
    hour:number = 0;
    minute:number = 0;
    second:number = 0;
    filterLeftPadd:FilterLeftPadd = new FilterLeftPadd();

    transform(inputValue:number,format:string):any {
        this.hour=0;
        this.minute=0;
        this.second=0;
        if(!inputValue){
            return "00:00:00";
        }
        if(!format){
            format = "dd HH:mm:ss";
        }

        let tmpSec:number = inputValue;
        let secDay = 60 * 60 * 24;
        let secHour = 60 * 60;
        let secMinute = 60;

        if(format.indexOf("d") > -1){
            if(tmpSec >= secDay) {
                this.day = Math.floor(tmpSec / secDay);
                tmpSec = tmpSec - (this.day * secDay);
            }
        }

        if(format.indexOf("H") > -1){
            if(tmpSec >= secHour) {
                this.hour = Math.floor(tmpSec / secHour);
                tmpSec = tmpSec - (this.hour * secHour);
            }
        }

        if(format.indexOf("m") > -1){
            if(tmpSec >= secMinute) {
                this.minute = Math.floor(tmpSec / secMinute);
                tmpSec = tmpSec - (this.minute * secMinute);
            }
        }

        this.second = tmpSec;

        if(format.indexOf("d") > -1 && this.day > 0){
            format = format.replace(/dd/g,`${this.day.toString()}일`);
        }else{
            format = format.replace(/dd\s+/g,"");
        }

        if(format.indexOf("H") > -1 && this.hour > 0){
            let hh = this.filterLeftPadd.transform(this.hour,2);
            format = format.replace(/HH/g,hh);
        }else{
            format = format.replace(/HH/g,"00");
        }

        if(format.indexOf("m") > -1 && this.minute > 0){
            let mm = this.filterLeftPadd.transform(this.minute,2);
            format = format.replace(/mm/g,mm);
        }else{
            format = format.replace(/mm/g,"00");
        }

        if(format.indexOf("s") > -1 && this.second > 0){
            let ss = this.filterLeftPadd.transform(this.second,2);
            format = format.replace(/ss/g,ss);
        }else{
            format = format.replace(/ss/g,"00");
        }
        return format;
    }
}
